import React from "react";
import { Link } from "react-router-dom";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import heroImage from "../Media/events/past/aus-eg-theatre.jpg";
import "./Topic.scss";

const Culture = () => {
  return (
    <>
      <NavBar />
      <main className="topic">
        <header className="topic__hero">
          <div className="container topic__heroInner">
            <div className="topic__heroText">
              <span className="eyebrow">Cultural Exchange</span>
              <h1 className="section-heading">
                Discover the Power of Cultural Exchange
              </h1>
              <p className="lede">
                Bridging communities, fostering growth, and creating synergies
                through culture.
              </p>
              <Link to="/membership" className="btn btn--filled">Join Us Today</Link>
            </div>
            <div className="topic__heroImage">
              <img src={heroImage} alt="Australian-Egyptian art and theatre collaboration" />
            </div>
          </div>
        </header>

        <section className="topic__body">
          <div className="container">
            <p className="lede">
              Joining ANZEG is more than just being part of a business group;
              it's entering into a community of growth-minded entities
              committed to mutual success. Through virtual networking events,
              mentorship programs, happy hours, and professional development
              workshops, these platforms enable businesses and individuals
              within the community to build and strengthen relationships
              with one another. Engaging in cultural activities can open
              doors for collaborations, partnerships, and even client
              referrals.
            </p>
            <p className="lede">
              Members can benefit from cultural sponsorship opportunities,
              referral programs, new member spotlights, and access to new
              advertising channels for a variety of cultural professionals
              including filmmakers, theatre practitioners, musicians,
              artists, writers and producers. Such collaborations not only
              help the member but also strengthen community ties and promote
              cultural diversity and tolerance, bringing cultural
              practitioners together from different nations to help build
              bridges of understanding and growth.
            </p>
          </div>
        </section>

        <section className="topic__about">
          <div className="container">
            <span className="eyebrow">About Us</span>
            <h2 className="section-heading section-heading--sm">
              ANZEG is dedicated to creating meaningful cultural exchanges
            </h2>
            <p className="lede">
              We believe in the transformative power of shared experiences
              and collaborative growth, connecting people across borders.
            </p>
          </div>
        </section>

        <section className="topic__benefits">
          <div className="container">
            <span className="eyebrow">Benefits</span>
            <h2 className="section-heading section-heading--sm">Member Benefits</h2>
            <ul className="marker-list">
              <li>Networking through virtual events, mentorship programs, and professional workshops</li>
              <li>Cultural sponsorship opportunities and referral programs</li>
              <li>New member spotlights and advertising channels for cultural professionals</li>
            </ul>
          </div>
        </section>

        <section className="topic__body">
          <div className="container">
            <span className="eyebrow">Collaboration</span>
            <h2 className="section-heading section-heading--sm">Building Cultural Synergies</h2>
            <p className="lede">
              ANZEG collaborates with local and international organizations
              to foster mutual benefits. Our members engage in joint
              ventures and co-hosted events with businesses and
              corporations. Opportunities include:
            </p>
            <ul className="marker-list">
              <li>Shared marketing efforts</li>
              <li>Event sponsorships and partnerships</li>
              <li>Community programs promoting cultural diversity and growth</li>
            </ul>
          </div>
        </section>

        <section className="topic__contact">
          <div className="container">
            <h2 className="section-heading section-heading--sm">Get in Touch</h2>
            <p className="lede">
              We'd love to hear from you! Reach out to us for more
              information or collaboration opportunities.
            </p>
            <a href="mailto:info@anzeginstitute.org" className="btn btn--filled">Contact Us</a>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Culture;
